<template>
  <div class="flex flex-col gap-2 w-full animate-pulse">
    <div
      v-for="n in 6"
      :key="n"
      class="flex justify-between items-center w-full px-[12px] py-[16px] rounded-lg bg-[#FAFAFA] border border-gray-100"
    >
      <div class="flex flex-col items-start gap-2">
        <div class="h-3 w-16 bg-slate-200 rounded"></div>
        <div class="h-4 w-48 bg-slate-200 rounded"></div>
      </div>

      <div class="flex gap-2">
        <div class="h-5 w-5 bg-slate-200 rounded"></div>
        <div class="h-5 w-5 bg-slate-200 rounded"></div>
        <div class="h-5 w-5 bg-slate-200 rounded"></div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts"></script>
